import { createContext, useContext } from "react";

/**
 * The element that owns the browser top layer while a modal sheet is open.
 * Portaled popups (Select, Popover, Menu) must mount inside this element;
 * anything mounted at document.body renders behind a native <dialog>.
 */
export const DialogSheetMountContext = createContext<HTMLElement | null>(null);

export function useDialogSheetMountElement(): HTMLElement | null {
  return useContext(DialogSheetMountContext);
}
